import React from 'react';

const at = (v) => { const d = new Date(v); return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); };

// The trip card line for an LTL load the driver works in the app: "5 of 10 stops done · 1 box mismatch · 1 issue". Pure.
export function driverStopsSummary(sf) {
  if (!sf) return null;
  const parts = [sf.completedAt ? `Trip completed · ${sf.total} stops` : `${sf.done} of ${sf.total} stops done`];
  if (sf.mismatches) parts.push(`${sf.mismatches} box mismatch${sf.mismatches === 1 ? '' : 'es'}`);
  if (sf.issues) parts.push(`${sf.issues} issue${sf.issues === 1 ? '' : 's'}`);
  return parts.join(' · ');
}

// Each stop as the driver reported it: when, boxes against the trip sheet, signed paperwork, issues
export default function DriverStops({ sf }) {
  if (!sf) return null;
  return (
    <div aria-label="Stops from the driver app">
      {sf.completedAt && <div className="tmw-small"><b>Trip completed</b> by {sf.completedBy || 'the driver'} · {at(sf.completedAt)}</div>}
      <table className="tmw-small" style={{ width: '100%', borderCollapse: 'collapse', marginTop: 6 }}>
        <thead><tr style={{ textAlign: 'left' }}><th>Stop</th><th>Done</th><th style={{ textAlign: 'right' }}>Boxes</th><th>Paperwork</th><th>Issues</th></tr></thead>
        <tbody>
          {sf.stops.map((x, i) => (
            <tr key={`${x.n}-${i}`} style={{ borderTop: '1px solid #e5e7eb', verticalAlign: 'top' }}>
              <td>{x.n != null ? `${x.n}. ` : '+ '}{x.customer}{x.city ? ` (${x.city})` : ''}</td>
              <td>{x.doneAt ? at(x.doneAt) : 'Not yet'}</td>
              <td style={{ textAlign: 'right', whiteSpace: 'nowrap', ...(x.diff ? { color: '#b91c1c', fontWeight: 600 } : {}) }}>{x.boxes != null ? `${x.boxes} of ${x.expected != null ? x.expected : '?'}` : x.expected != null ? `— of ${x.expected}` : '—'}{x.diff ? ` (${x.diff > 0 ? '+' : ''}${x.diff})` : ''}</td>
              <td>{x.paperwork ? `Signed (${x.paperwork})` : x.doneAt ? 'None sent' : ''}</td>
              <td>{x.issues.map((s) => <div key={s.at}>{s.text || 'Photos'}{s.photos ? ` · ${s.photos} photo${s.photos === 1 ? '' : 's'}` : ''}</div>)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
